import React from "react";
import "./FloatingActions.css"; // import the CSS

export default function FloatingActions() {
  const phone = "917350552704";
  const message = encodeURIComponent(
    "Hello Hygenic Agro, I'm interested in your fertilizers!"
  );

  return (
    <div className="floating-actions">
      {/* WhatsApp Button */}
      <a
        href={`https://wa.me/${phone}?text=${message}`}
        target="_blank"
        rel="noreferrer"
        className="fab whatsapp"
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
          alt="WhatsApp"
          className="icon"
        />
        <span className="tooltip">Chat with us</span>
      </a>

      {/* Call Button */}
      <a href={`tel:+${phone}`} className="call-btn">
        Call Now
      </a>
    </div>
  );
}
